export type AttendanceView = 'pending' | 'anomalies' | 'people';

export const ATTENDANCE_VIEWS: readonly AttendanceView[] = ['pending', 'anomalies', 'people'];

/**
 * 考勤页打开时默认落在哪个页签（CR-052，照采购的 `defaultPurchaseStatus`）。
 *
 * - 能复核 / 补录的人（`attendance.manage`）：有待复核 → 待复核；没有、有异常 → 异常；都没有 → 按人汇总；
 * - 只能看考勤的人：按人汇总 —— 待复核和异常对他只是看，不是事。
 *
 * 能复核、但数还没回来时返回 `undefined`：先别落，落错一次再跳一次比多转一圈更让人迷糊。
 */
export function defaultAttendanceView(
  canManage: boolean,
  counts: { pending: number; anomalies: number } | undefined,
): AttendanceView | undefined {
  if (!canManage) return 'people';
  if (!counts) return undefined;
  if (counts.pending > 0) return 'pending';
  if (counts.anomalies > 0) return 'anomalies';
  return 'people';
}

/** `?view=` 的值；不认识的当没选 */
export function parseAttendanceView(value: string | null): AttendanceView | undefined {
  return ATTENDANCE_VIEWS.find((view) => view === value);
}
